<div class="layout-column full-height">

  <div class="layout-row layout-align-start-center jobs-header padding-5">
    <app-bringoz-search-input class="flex"
                              [query]="panel.filtersConfig.queryString"
                              (queryChangeEvent)="onQueryChange($event)">

    </app-bringoz-search-input>

    <bringoz-button type="tertiary"
                    (onClick)="onToggleFilters($event)">
      <bringoz-icon iconName="filter"></bringoz-icon>
    </bringoz-button>

    <bringoz-button type="tertiary"
                    [isDisabled]="isDateBrowseDisabled(panel.filtersConfig.range.dateStart, (visitPlanRange?.dateStart || visitPlan.from))"
                    (onClick)="onDatesBrowse(false)">
      <bringoz-icon iconName="chevron-left"></bringoz-icon>
    </bringoz-button>

    <bringoz-button type="tertiary"
                    (onClick)="onOpenDaySelectDialog($event)">
      <span>{{ panel.filtersConfig.range | bringozDay: 'dateStart': 'long' }} {{ panel.filtersConfig.range | bringozDate: 'dateStart' }}</span>
    </bringoz-button>

    <bringoz-button type="tertiary"
                    [isDisabled]="isDateBrowseDisabled(panel.filtersConfig.range.dateEnd, (visitPlanRange?.dateEnd || visitPlan.to))"
                    (onClick)="onDatesBrowse(true)">
      <bringoz-icon iconName="chevron-right"></bringoz-icon>
    </bringoz-button>


    <span class="flex"></span>
    <bringoz-button type="tertiary"
                    theme="secondary"
                    [isDisabled]="!selectedIds?.length || visitPlan?.hasNotSyncedChanges || isSelectedJobsDayDispatched"
                    [ngbTooltip]="blockedActionTooltipKey | translate"
                    container="body"
                    openDelay="300"
                    (onClick)="onAssign.emit({ event: $event, jobIds: selectedIds, visitPlan, dateRange })">

      <span class="br-body-1 font-weight-400">{{'Assign' | translate}} {{selectedIds?.length}}</span>

    </bringoz-button>

    <bringoz-button type="tertiary"
                    (onClick)="onClose.emit()"
                    [ngbTooltip]="'close' | translate"
                    openDelay="300"
                    triggers="hover"
                    aria-label="Close">
      <bringoz-icon iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>

  <hr class="main-divider">

  <!--Table View-->
  <div  class="flex layout-column bringoz-table">
    <div id="header" class="tr layout-row layout-align-start-center">

      <div class="flex layout-row layout-align-start-start th large text-center">
        <span translate>Store</span>
      </div>

      <div class="flex-10 layout-row layout-align-center-center th text-center">
        <span>D</span>
      </div>

      <!--      <div class="flex layout-row layout-align-start-start th large text-center">-->
      <!--        <span translate>Address</span>-->
      <!--      </div>-->

      <div class="flex layout-row layout-align-start-start th large text-center">
        <span translate>Time Window</span>
      </div>

      <div class="flex-20 layout-row layout-align-start-start th large text-center">
        <span [ngbTooltip]="'In-store Time' | translate"
              openDelay="300"
              triggers="hover"
              container="body"
              translate>S.Time</span>
      </div>

    </div>
    <!--Table Body-->

    <div class="flex layout-column rows-container full-height">

      <!--Repeater-->
      <!--      <div *ngIf="!!jobs && jobs?.length" class="full-height flex layout-column">-->
      <!--        <cdk-virtual-scroll-viewport *ngIf="!!jobs && jobs?.length"-->
      <!--                                     [itemSize]="50" class="flex viewport"-->
      <!--                                     (scroll)="getNextBatch()">-->

      <!--          <app-visit-plan-jobs-panel-item class="item"-->
      <!--                                          *cdkVirtualFor="let job of jobs"-->
      <!--                                          [job]="job"-->
      <!--                                          [visitPlan]="visitPlan"-->
      <!--                                          [isSelected]="selectedKeys[job.id]"-->
      <!--                                          [programTypeAliasMap]="programTypeAliasMap"-->
      <!--                                          (onToggle)="onToggleJobSelect($event)">-->

      <!--          </app-visit-plan-jobs-panel-item>-->

      <!--        </cdk-virtual-scroll-viewport>-->
      <!--      </div>-->

      <cdk-virtual-scroll-viewport *ngIf="!!jobs && jobs?.length"
                                   [itemSize]="50" class="flex viewport"
                                   (scroll)="getNextBatch()">


        <div cdkDropList
             id="{{panel.id}}"
             [cdkDropListData]="jobs"
             [cdkDropListConnectedTo]="connectedPanelIds"
             (cdkDropListDropped)="drop($event)">
          <app-visit-plan-jobs-panel-item class="item"
                                          *cdkVirtualFor="let job of jobs"
                                          [job]="job"
                                          [visitPlan]="visitPlan"
                                          [isSelected]="selectedKeys[job.id]"
                                          cdkDrag
                                          [cdkDragData]="job"
                                          [programTypeAliasMap]="programTypeAliasMap"
                                          (onToggle)="onToggleJobSelect($event)"
                                          (onLockJobChange)="onLockJobChange.emit($event)">

            <div cdkDragHandle>
              <bringoz-icon iconName="drag" class="secondary-100"></bringoz-icon>
            </div>

            <div *ngIf="selectedIds.length > 1 && selectedKeys[job.id]">
              <div *cdkDragPreview
                   id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
                {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedIds.length} }}
              </div>
            </div>

          </app-visit-plan-jobs-panel-item>
        </div>

      </cdk-virtual-scroll-viewport>

      <div *ngIf="!!jobs && !jobs?.length"
           class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
        <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png"
                         text="No Services Found">

        </app-empty-state>
      </div>
      <div *ngIf="!jobs"
           class="flex layout-row layout-align-center-center">
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
  </div>

  <!--Map View-->
<!--  <div *ngIf="isMapView" class="flex layout-column">-->
<!--    <app-visit-plan-jobs-map class="flex padding-5"-->
<!--                             [jobs]="jobs"-->
<!--                             [selectedIds]="selectedIds"-->
<!--                             (jobSelectEvent)="onToggleJobSelect($event)">-->
<!--    </app-visit-plan-jobs-map>-->
<!--  </div>-->

  <app-bringoz-linear-progress *ngIf="!!isLoading"></app-bringoz-linear-progress>

</div>
